<template>
  <ul class="nav nav-tabs my-4">
    <li class="nav-item">
      <a href="#" class="nav-link text-dark" :class="{ active: utilityTab === 'notes' }" @click.prevent="setUtilityTab('notes')">
        {{ 'Notes' | translate }}
      </a>
    </li>
  </ul>
</template>

<script>
import _ from 'lodash'
export default {
  computed: {
    utilityTab() {
      return this.$store.state.lectureUtilityTab
    },
    lecture() {
      return _.flatten(this.$store.state.course.sections.map((section) => section.lectures)).find(
        (lecture) => lecture.id == this.$route.params.lecture,
      )
    },
  },
  methods: {
    setSideBarLeft(type) {
      this.$store.commit('toggleUtilityTab', null)
    },
    setUtilityTab(type) {
      this.$store.commit('toggleUtilityTab', type)
    },
  },
}
</script>

<style></style>
